<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Senarai Aduan / Maklumbalas">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt2">
                    <div class="xs6 mr3">
                        <w-input type="date" v-model="cari.dari"
                            >Tarikh Aduan</w-input
                        >
                    </div>
                    <div class="xs6 mr3">
                        <w-input type="date" v-model="cari.hingga"
                            >Hingga</w-input
                        >
                    </div>
                    <div class="xs6 mr5">
                        <z-lookup
                            label="Klasifikasi"
                            :url="service_utiliti + 'lookup/aduan'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_aduan_id"
                        />
                    </div> </w-flex
            ></w-form>
            <w-form ref="dform" @validate="search">
                <w-flex class="mt2">
                    <div class="xs6 mr5">
                        <z-lookup
                            label="Sumber"
                            :url="service_utiliti + 'lookup/sumber_aduan'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_aduan_sumber_id"
                        />
                    </div>
                    <div class="xs6 mr5">
                        <z-lookup
                            label="Status"
                            :url="service_utiliti + 'lookup/status_aduan'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_aduan_status_id"
                        />
                    </div> </w-flex
            ></w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>

                    <w-button
                        class="ml1"
                        @click="$refs.dform.validate()"
                        :loading="cari.loading"
                    >
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>
            <br />
            <center v-if="cari.loading">
                <w-progress class="ma1" circle></w-progress>
            </center>

            <!-- <w-dialog
                v-model="modal.show"
                :fullscreen="modal.fullscreen"
                :width="modal.width"
                :persistent="modal.persistent"
                :persistent-no-animation="modal.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title> Aduan </template>
                <template #default>
                    <w-flex class="mt3">
                        <div class="xs4">
                            <h5 class="fw-semibold m0">No Aduan :</h5>
                            <div class="fw-normal my1 fs-1">
                                {{ form.no_aduan }}
                            </div>
                        </div>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">Tarikh Aduan :</h5>
                            <div class="fw-normal my1 fs-1">
                                {{ $zutil.dateformat(form.created_at) }}
                            </div>
                        </div>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">Status :</h5>
                            <div class="fw-normal my1 fs-1">
                                {{ form.status_aduan }}
                            </div>
                        </div>
                    </w-flex>

                    <w-flex class="mt3">
                        <div class="xs4">
                            <h5 class="fw-semibold m0">Klasifikasi :</h5>
                            <div class="fw-normal my1 fs-1">
                                {{ form.aduan }}
                            </div>
                        </div>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">Sumber :</h5>
                            <div class="fw-normal my1 fs-1">
                                {{ form.sumber_aduan }}
                            </div>
                        </div>
                    </w-flex>
                    <br />
                    <w-tabs
                        :items="tabs"
                        :no-slider="false"
                        active-class="primary"
                    >
                        <template #item-content.1>
                            <w-flex class="mt3">
                                <div class="xs4">
                                    <h5 class="fw-semibold m0">Nama:</h5>
                                    <div class="fw-normal my1 fs-1">
                                        {{ form.nama }}
                                    </div>
                                </div>
                                <div class="xs4">
                                    <h5 class="fw-semibold m0">Emel:</h5>
                                    <div class="fw-normal my1 fs-1">
                                        {{ form.emel }}
                                    </div>
                                </div>
                                <div class="xs4">
                                    <h5 class="fw-semibold m0">No Telefon:</h5>
                                    <div class="fw-normal my1 fs-1">
                                        {{ form.no_telefon }}
                                    </div>
                                </div>
                            </w-flex>
                        </template>
                        <template #item-content.2>
                            <w-flex class="mt3">
                                <div class="xs12">
                                    <w-image
                                        width="100%"
                                        tag="img"
                                        style="max-width: 700px"
                                        :src="form.lampiran_gambar"
                                        alt="Tiada Lampiran"
                                    ></w-image>
                                    <h5 class="fw-semibold m0">Keterangan:</h5>
                                    {{ form.keterangan }}
                                </div>
                            </w-flex>
                            <w-flex class="mt3">
                                <div class="xs12">
                                    <h5 class="fw-semibold m0">Maklumbalas:</h5>
                                    <div class="fw-normal my1 fs-1">
                                        {{ form.maklum_balas }}
                                    </div>
                                </div>
                            </w-flex>
                        </template>
                        <template #item-content.3>
                            <table class="w-table">
                                <thead>
                                    <tr>
                                        <th
                                            class="w-table__header w-table__header--sortable text-left"
                                        >
                                            No
                                        </th>
                                        <th
                                            class="w-table__header w-table__header--sortable text-left"
                                        >
                                            Tindakan
                                        </th>
                                        <th
                                            class="w-table__header w-table__header--sortable text-left"
                                        >
                                            Pengguna
                                        </th>
                                        <th
                                            class="w-table__header w-table__header--sortable text-left"
                                        >
                                            Tarikh
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(dt, index) in form.jejak_audit">
                                        <td class="w-table__cell text-left">
                                            {{ index + 1 }}
                                        </td>
                                        <td class="w-table__cell text-left">
                                            {{ dt.tindakan_aduan_keterangan }}
                                        </td>
                                        <td class="w-table__cell text-left">
                                            {{ dt.user_nama }}
                                        </td>
                                        <td class="w-table__cell text-left">
                                            {{ dt.tarikh }}
                                        </td>
                                    </tr>
                                    <tr v-if="form.jejak_audit.length == 0">
                                        <td
                                            class="w-table__cell text-left"
                                            colspan="5"
                                        ></td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                        <template #item-content.4>
                            <table class="w-table">
                                <thead>
                                    <tr>
                                        <td width="2%">No</td>
                                        <td>Lampiran</td>
                                        <td width="15%">Tarikh</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <td>
                                        <template v-if="dt.lampiran_nama">
                                            <a
                                                :href="
                                                    dt.lampiran_url.replace(
                                                        'https://ihasil.kedah.gov.my/api/utiliti-service/'
                                                    )
                                                "
                                                >{{ dt.lampiran_nama }}</a
                                            >
                                        </template>
                                    </td>
                                </tbody>
                            </table>
                        </template>
                    </w-tabs>
                </template>
                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="modal.show = false"
                        >Tutup</w-button
                    >
                </template>
            </w-dialog> -->

            <w-dialog
                v-model="dialog.show"
                :fullscreen="dialog.fullscreen"
                :width="dialog.width"
                :persistent="dialog.persistent"
                :persistent-no-animation="dialog.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title> Aduan </template>
                <template #default>
                    <w-flex class="mt3">
                        <div class="xs4">
                            <h5 class="fw-semibold m0">No Aduan :</h5>
                            <div class="fw-normal my1 fs-1">
                                {{ form.no_aduan }}
                            </div>
                        </div>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">Tarikh Aduan :</h5>
                            <div class="fw-normal my1 fs-1">
                                {{ $zutil.dateformat(form.created_at) }}
                            </div>
                        </div>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">Status :</h5>
                            <div class="fw-normal my1 fs-1">
                                {{ form.status_aduan }}
                            </div>
                        </div>
                    </w-flex>

                    <w-flex class="mt3">
                        <div class="xs4">
                            <h5 class="fw-semibold m0">Klasifikasi :</h5>
                            <div class="fw-normal my1 fs-1">
                                {{ form.aduan }}
                            </div>
                        </div>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">Sumber :</h5>
                            <div class="fw-normal my1 fs-1">
                                {{ form.sumber_aduan }}
                            </div>
                        </div>
                    </w-flex>
                    <br />

                    <w-tabs
                        :items="tabs"
                        :no-slider="false"
                        active-class="primary"
                    >
                        <template #item-content.1>
                            <w-flex class="mt3">
                                <div class="xs4">
                                    <h5 class="fw-semibold m0">Nama:</h5>
                                    <div class="fw-normal my1 fs-1">
                                        {{ form.nama }}
                                    </div>
                                </div>
                                <div class="xs4">
                                    <h5 class="fw-semibold m0">Emel:</h5>
                                    <div class="fw-normal my1 fs-1">
                                        {{ form.emel }}
                                    </div>
                                </div>
                                <div class="xs4">
                                    <h5 class="fw-semibold m0">No Telefon:</h5>
                                    <div class="fw-normal my1 fs-1">
                                        {{ form.no_telefon }}
                                    </div>
                                </div>
                            </w-flex>
                        </template>
                        <template #item-content.2>
                            <w-flex class="mt3">
                                <div class="xs12">
                                    <w-image
                                        width="100%"
                                        tag="img"
                                        style="max-width: 700px"
                                        :src="form.lampiran_gambar"
                                        alt="Tiada Lampiran"
                                    ></w-image>
                                    <h5 class="fw-semibold m0">Keterangan:</h5>
                                    {{ form.keterangan }}
                                </div>
                            </w-flex>
                            <w-form
                                ref="form"
                                v-model="dialog.valid"
                                @validate="submit(2)"
                                @success="onSuccess"
                            >
                                <w-flex class="mt3">
                                    <w-textarea
                                        outline
                                        v-model="form.maklum_balas"
                                        name="maklum_balas"
                                        :validators="[validators.required]"
                                        rows="6"
                                        >Maklumbalas</w-textarea
                                    >
                                </w-flex>
                            </w-form>
                        </template>
                        <template #item-content.3>
                            <table class="w-table">
                                <thead>
                                    <tr>
                                        <th
                                            class="w-table__header w-table__header--sortable text-left"
                                        >
                                            No
                                        </th>
                                        <th
                                            class="w-table__header w-table__header--sortable text-left"
                                        >
                                            Tindakan
                                        </th>
                                        <th
                                            class="w-table__header w-table__header--sortable text-left"
                                        >
                                            Pengguna
                                        </th>
                                        <th
                                            class="w-table__header w-table__header--sortable text-left"
                                        >
                                            Tarikh
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(dt, index) in form.jejak_audit">
                                        <td class="w-table__cell text-left">
                                            {{ index + 1 }}
                                        </td>
                                        <td class="w-table__cell text-left">
                                            {{ dt.tindakan_aduan_keterangan }}
                                        </td>
                                        <td class="w-table__cell text-left">
                                            {{ dt.user_nama }}
                                        </td>
                                        <td class="w-table__cell text-left">
                                            {{ dt.tarikh }}
                                        </td>
                                    </tr>
                                    <tr v-if="form.jejak_audit.length == 0">
                                        <td
                                            class="w-table__cell text-left"
                                            colspan="5"
                                        ></td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                        <template #item-content.4>
                            <table class="w-table">
                                <thead>
                                    <tr>
                                        <th
                                            class="w-table__header w-table__header--sortable text-left"
                                        >
                                            No
                                        </th>
                                        <th
                                            class="w-table__header w-table__header--sortable text-left"
                                        >
                                            Lampiran
                                        </th>

                                        <th
                                            class="w-table__header w-table__header--sortable text-left"
                                        >
                                            Tarikh
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(dt, index) in form.lampir">
                                        <td class="w-table__cell text-left">
                                            {{ index + 1 }}
                                        </td>
                                        <td class="w-table__cell text-left">
                                            <a :href="dt.url"> {{ dt.nama }}</a>
                                        </td>
                                        <td class="w-table__cell text-left">
                                            {{
                                                $zutil.dateformat(dt.created_at)
                                            }}
                                        </td>
                                    </tr>
                                    <!-- <tr v-if="form.lampiran.length == 0">
                                        <td
                                            class="w-table__cell text-left"
                                            colspan="3"
                                        ></td>
                                    </tr> -->
                                </tbody>
                            </table>
                        </template>
                    </w-tabs>
                </template>
                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialog.show = false"
                        >Tutup</w-button
                    >
                    <w-button
                        class="ml1"
                        :loading="dialog.loading"
                        :disabled="dialog.valid === false"
                        @click="$refs.form.validate()"
                        >Hantar</w-button
                    >
                </template>
            </w-dialog>

            <z-table
                ref="tbluser"
                title="Senarai Aduan / Maklumbalas"
                :headers="table.headers"
                :items="table.items"
                :meta="table.meta"
                class=""
            >
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'status_aduan'">
                        Status
                    </template>
                </template>
                <template
                    #item-cell.status_aduan="{ item, label, header, index }"
                >
                    <w-flex class="flex justify-center">
                        <template v-if="item.lkp_aduan_status_id == 2">
                            <button type="button" class="btn-selesai">
                                SELESAI
                            </button>
                        </template>
                        <template v-if="item.lkp_aduan_status_id == 1">
                            <template v-if="item.tempoh >= 30">
                                <button type="button" class="btn-sebulan">
                                    TIADA MAKLUM BALAS
                                </button>
                            </template>
                            <template
                                v-if="item.tempoh > 7 && item.tempoh < 30"
                            >
                                <button type="button" class="btn-seminggu">
                                    TINDAKAN SUSULAN
                                </button>
                            </template>
                            <template v-if="item.tempoh <= 7">
                                <button type="button" class="btn-baharu">
                                    BAHARU
                                </button>
                            </template>
                        </template>
                    </w-flex>
                </template>
                <template v-if="header.key == 'action'"> Tindakan </template>
                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                        <!-- <w-tooltip top>
                            <template #activator="{ on }">
                                <template v-if="item.lkp_aduan_status_id == 2">
                                <w-icon v-on="on" tile @click="show(item)">
                                    fal fa-eye
                                </w-icon>
                                </template>
                            </template>
                            Papar
                        </w-tooltip> -->
                        <w-tooltip top>
                            <template #activator="{ on }">
                                <template v-if="item.lkp_aduan_status_id">
                                    <w-icon v-on="on" tile @click="edit(item)">
                                        fal fa-pencil
                                    </w-icon>
                                </template>
                            </template>
                            Kemaskini
                        </w-tooltip>
                    </w-flex>
                </template>
            </z-table>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_utiliti + "aduan",
            reload: true,
            form: {},
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/ihasil" },
                { label: "Utiliti", route: "/utiliti" },
                { label: "Aduan", route: "/utiliti/aduan" },
            ],
            tabs: [
                { title: "Profil", content: "" },
                { title: "Butiran", content: "" },
                { title: "Jejak Audit", content: "" },
                { title: "Lampiran", content: "" },
            ],
            cari: {
                dari: "",
                hingga: "",
                lkp_aduan_id: "",
                lkp_aduan_sumber_id: "",
                lkp_aduan_status_id: "",
                // lkp_tuntutan_bantuan_perihal_id: "",
                // lkp_tuntutan_bantuan_status_id: "",
            },
        };
    },
    methods: {
        search() {
            this.cari.loading = true;
            this.$inertia.visit(
                window.route("utiliti.aduan.index") +
                    "&dari=" +
                    this.cari.dari +
                    "&hingga=" +
                    this.cari.hingga +
                    "&lkp_aduan_id=" +
                    this.cari.lkp_aduan_id +
                    "&lkp_aduan_sumber_id=" +
                    this.cari.lkp_aduan_sumber_id +
                    "&lkp_aduan_status_id=" +
                    this.cari.lkp_aduan_status_id,
                { preserveScroll: true }
            );
        },

        reset() {
            this.cari = {
                dari: "",
                hingga: "",
                lkp_aduan_id: "",
                lkp_aduan_sumber_id: "",
                lkp_aduan_status_id: "",
                // lkp_tuntutan_bantuan_status_id: "",
            };
            this.search();
        },
        onSuccess() {
            setTimeout(() => (this.form.sent = true), 2000);
            // this.$inertia.visit(window.route('utiliti.aduan.index'));
            this.$inertia.visit(this.$page.url);
        },

        submit(status) {
            this.form.lkp_aduan_status_id = status;
            this.form.lkp_tindakan_id = 2;
            this.$zcomm
                .update(
                    this.resourceurl + "/" + this.form.id,
                    this.form.id,
                    this.form
                )
                .then((res) => {
                    //update displayed record
                    this.mapreturneddata(res);
                    this.modal.show = false;

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit();
                    }
                    this.$inertia.visit(window.route("utiliti.aduan.index"));
                })
                .catch((err) => {})
                .finally(() => {
                    this.dialog.loading = false;
                    // this.dialog.show = false
                });
        },
    },
    watch: {},
    mounted() {
        // override default setting
        // this.getData();
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.dari == "undefined") {
            this.cari.dari = "";
        }
        if (this.cari.hingga == "undefined") {
            this.cari.hingga = "";
        }
        if (this.cari.lkp_aduan_id == "undefined") {
            this.cari.lkp_aduan_id = "";
        }
        if (this.cari.lkp_aduan_sumber_id == "undefined") {
            this.cari.lkp_aduan_sumber_id = "";
        }
        if (this.cari.lkp_aduan_status_id == "undefined") {
            this.cari.lkp_aduan_status_id = "";
        }
        // if (this.cari.nama_id == "undefined") {
        //     this.cari.nama_id = "";
        // }
        // if (this.cari.lkp_tuntutan_bantuan_status_id == "undefined") {
        //     this.cari.lkp_tuntutan_bantuan_status_id = "";
        // }
    },
};
</script>

<style>
.w-select__menu {
    z-index: 999999;
}

.btn-selesai {
    border-radius: 4px;
    background-color: #4caf50; /* Green */
    border: none;
    color: white;
    padding: 4px 10px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 12px;
    margin: 2px 1px;
    font-weight: 550;
}

.btn-baharu {
    border-radius: 4px;
    background-color: #008cba; /* Green */
    border: none;
    color: white;
    padding: 4px 8px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 12px;
    margin: 2px 1px;
    font-weight: 550;
}

.btn-seminggu {
    border-radius: 4px;
    background-color: #ffc300; /* Green */
    border: none;
    color: white;
    padding: 4px 8px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 12px;
    margin: 2px 1px;
    font-weight: 550;
}

.btn-sebulan {
    border-radius: 4px;
    background-color: #c70039; /* Green */
    border: none;
    color: white;
    padding: 4px 8px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 12px;
    margin: 2px 1px;
    font-weight: 550;
}
</style>
